import React, { createContext, useState, useEffect } from 'react';

export const DataContext = createContext(null);

export const DataProvider = ({ children }) => 
{
    const loadFrom = (key, defaultValue) => 
    {
      try 
      {
        const storedValue = sessionStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : defaultValue;
      } 
      catch (error) 
      {
        console.error(`Error accessing sessionStorage for key "${key}":`, error);
        return defaultValue;
      }
      
    };

    const [loginData, setLoginData] = useState(() => loadFrom('loginData', { isLoggedIn: false }) );

    // Sync loginData with sessionStorage
    useEffect(() => {
      try { sessionStorage.setItem('loginData', JSON.stringify(loginData)); }
      catch (error) { console.error('Error saving loginData to sessionStorage:', error); }
    }, [loginData]);

  return (
    <DataContext.Provider value={{ loginData, setLoginData }} >
      {children}
    </DataContext.Provider>
  );
};
